import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import useFetch from '../../../../../hooks/useAxios';
import Button from '../../../../shared/Button';
import Input from '../../../../shared/Input'
import Modal from '../../../../shared/Modal'

const WageForAllRes = ({closeModal,apiWageList}) => {
    const [WagePerc, setWagePerc] = useState()
    const {
        handleSubmit,
        formState: { errors, isValid },
        control,
        reset
      } = useForm();
      const postWageForAll = useFetch({
        method: "post",
        url: "api/admin/wages/store/general",
        noHeader: false,
        trigger: false,
        data:WagePerc,
        caller:apiWageList,
        argFunc:res=>{
            toast.success("رزرو به حالت تایید شده در آمد")
            closeModal()
        }
        
      });
    const onSubmit = (data)=>{
        setWagePerc({...data,residence_type:"general"})
    }
    useEffect(() => {
      
        if(WagePerc){
            postWageForAll.reFetch() 
        }
    }, [WagePerc])
    
  return (
    <div className='ModalBackground WageForAllRes'>
        <div className='ModalBackground--container p-[32px]'>
            <h3 className='text-[#00A6A6] text-[24px] font-[700]'>کارمرزد عمومی</h3>
            <p className='text-[#5B5F64] text-[16px] font-[400] mt-[12px] mb-[64px]'>به خاطر داشته باشید میزان تخفیفی که در نظر میگیرد به تمام اقامتگاه ها اعمال میشود</p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='text-[#292D32] text-[20px] font-[700]'>
                میزان کارمزد
                </div>
            <div className='WageForAllRes--row'>
            <Input
            name="wage_percentage"
            control={control}
            errors={errors}
            placeholder="25% کارمزد عمومی"
            
            className="secondary-input my-[20px]"
            register={{
              required: "  کارمزد عمومی اجباری است"
            }}
          />
          <Button varient="secondary">اعمال</Button>
            </div>
            </form>
            <Button onClick={closeModal} varient="primary" fullwidth className="mt-[12px]">انصراف</Button>
        </div>
    </div>
  )
}

export default WageForAllRes